import { render, staticRenderFns } from "./paperInterviewDetail.vue?vue&type=template&id=6a02e65d&scoped=true&"
import script from "./paperInterviewDetail.vue?vue&type=script&lang=js&"
export * from "./paperInterviewDetail.vue?vue&type=script&lang=js&"
import style0 from "./paperInterviewDetail.vue?vue&type=style&index=0&id=6a02e65d&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a02e65d",
  null
  
)

export default component.exports